

export function PyramidChart(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            {...props}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke="currentColor"
            strokeWidth="currentStroke"
        >
            <path
                d="M11.8658 3.26833L3.10854 20.7829C3.05867 20.8827 3.1312 21 3.2427 21H20.7573C20.8688 21 20.9413 20.8827 20.8915 20.7829L12.1342 3.26833C12.0789 3.15777 11.9211 3.15777 11.8658 3.26833Z"
                 strokeLinecap="round"/>
            <path d="M19 17H5" strokeLinecap="round"/>
            <path d="M17 13H7" strokeLinecap="round"/>
            <path d="M15 9H9" strokeLinecap="round"/>
        </svg>

    )
}